// Mock Symptoms Data
// Extracted from demo-data/symptoms.ts

export interface SymptomEntry {
  id: string;
  user_id: string;
  symptom_name: string;
  severity: number;
  duration: string;
  notes?: string;
  logged_at: string;
  created_at: string;
}

export const mockSymptoms: SymptomEntry[] = [
  {
    id: '1',
    user_id: 'demo-user-id',
    symptom_name: 'Headache',
    severity: 5,
    duration: '2 hours',
    notes: 'Mild headache, possibly stress-related',
    logged_at: new Date().toISOString(),
    created_at: new Date().toISOString()
  },
  {
    id: '2',
    user_id: 'demo-user-id',
    symptom_name: 'Fatigue',
    severity: 7,
    duration: 'All day',
    notes: 'Feeling tired throughout the day',
    logged_at: new Date().toISOString(),
    created_at: new Date().toISOString()
  },
  {
    id: '3',
    user_id: 'demo-user-id',
    symptom_name: 'Nausea',
    severity: 3,
    duration: '30 minutes',
    notes: 'Mild nausea after lunch',
    logged_at: new Date().toISOString(),
    created_at: new Date().toISOString()
  }
]; 